<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
</script>

<template>
    <AccordionItem value="sales" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'analytics']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">Sales</div>
            </div>
        </AccordionTrigger>
        <AccordionContent class="pb-0 text-xs">
            <div class="flex flex-col text-white">
                <RouterLink to="/sales/orders" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Orders</RouterLink
                >
                <RouterLink to="/sales/products" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Products</RouterLink
                >
                <RouterLink to="/sales/packages" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Packages</RouterLink
                >
                <RouterLink
                    to='/sales/rates?sort=[{"column":"title","direction":"asc"}]'
                    class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Rates</RouterLink
                >
                <RouterLink to="/sales/services" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Services</RouterLink
                >
                <RouterLink to="/sales/datum" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Datum</RouterLink
                >
                <RouterLink to="/sales/tariffs" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Tariffs</RouterLink
                >
            </div>
        </AccordionContent>
    </AccordionItem>
</template>

<style scoped>
.router-link-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
